<template>

<div class="wrapper">

  <PageHeader :title="chapter ? `Study ${chapter.title}` : 'Loading...'">

    <ol class="breadcrumb pull-left" style="margin-top: 0;">
      <li>
        <router-link :to="{name: 'subject-shelf'}"><i class="icon mdi mdi-arrow-left"></i> &nbsp;Home</router-link>
      </li>
    </ol>

    <div v-if="microNotes && microNotes.length" style="float: right;">

      <KeywordSettings :chapterId="chapter.chapter_id" class="pull-right" />

      <div class="email-filters-right  text-right pull-right xs-mr-10">
        <span class="email-pagination-indicator">{{microNotes.length}} remaining&nbsp;</span>
        <div class="btn-group email-pagination-nav">
          <button v-on:click.prevent="previousMicroNote" type="button" class="btn btn-default"><i class="mdi mdi-chevron-left"></i></button>
          <button v-on:click.prevent="nextMicroNote" type="button" class="btn btn-default"><i class="mdi mdi-chevron-right"></i></button>
        </div>
      </div>

    </div><!-- /slot -->
    <div class="clearfix"></div>
  </PageHeader>

  <div class="chapterStudier main-content container-fluid">
    <div class="row">
      <div class="col-md-12">

        <Panel class="panel panel-default">

          <PanelBody v-if=" !chapter || !microNotes">
            <LoadingIndicator />
          </PanelBody>


          <PanelBody v-else-if=" !chapter.micro_notes_count">
            <!-- The chapter actually has no micro notes -->
            <div role="alert" class="sm-mt-20 alert alert-primary alert-icon alert-icon-border">
              <div class="icon"><span class="mdi mdi-info-outline"></span></div>
              <div class="message">
                <strong>Empty!</strong> This chapter has no micro notes.
              </div>
            </div>
          </PanelBody>

          <PanelBody v-else-if=" !microNotes.length">
            <!-- Chapter has micro notes, but they've all been studied -->
            <div role="alert" class="sm-mt-20 alert alert-success alert-icon alert-icon-border">
              <div class="icon"><span class="mdi mdi-info-outline"></span></div>
              <div class="message">
                <strong>Good!</strong> You've finished studying the micro notes in this chapter.
              </div>
            </div>

            <p><img :src="successImageUrl" /></p>

          </PanelBody>

          <!-- Study a single micro note. microNote is available here -->
          <div v-else>

            <MicroNoteImageStudier v-if="microNote && microNote.micro_note_type === 'image'" :microNote="microNote" />
            <MicroNoteStudier v-else :microNote="microNote" />

            <!-- Bottom shelf + wordbank -->
            <BottomShelf :microNote="microNote" :chapter="chapter" />
          </div>
        </Panel>


      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.main-content -->
</div><!-- /.div -->

</template>


<script>
import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Chapter from '../../resources/chapter'
import MicroNote from '../../resources/microNote'
import BottomShelf from './BottomShelf'
import MicroNoteStudier from './MicroNoteStudier'
import MicroNoteImageStudier from './MicroNoteImageStudier'
import KeywordSettings from '../micro-note-editor/KeywordSettings'


export default {
  components: {
    BottomShelf,
    MicroNoteStudier,
    MicroNoteImageStudier,
    KeywordSettings,
  },

  beforeCreate() {
    this.$store.dispatch('getChapters')
    this.$store.dispatch('getMicroNotes')
    this.$store.commit('studier/LOAD_CHAPTER', {chapterId: this.$route.params.chapterId})


  },

  created() {
    // listen for keypress events and fill in active keyword
    $(window).on('keypress.chapterStudier', this.handleKeypress);
    $(window).on('keydown.chapterStudier', this.handleKeydown);

    this.successImageUrl = _.sample(this.successGifs);
  },

  beforeDestroy() {
    $(window).off('keypress.chapterStudier');
    $(window).off('keydown.chapterStudier');
  },

  methods: {

    nextMicroNote() {
      this.$store.dispatch('studier/nextMicroNote')
    },

    previousMicroNote() {
      this.$store.dispatch('studier/previousMicroNote')
    },

    // Handles arrow keys and enter
    handleKeydown(e) {
      const key = e.key.toLowerCase();
      switch(key) {
        // case 'arrowright':
        // case 'tab':
        case 'enter':
          this.$store.dispatch('studier/nextKeyword')
          break;
        // case 'arrowleft':
        //   console.log("#todo previous")
        //   break;
        case 'backspace':
          let answer = this.currentKeyword.answer || '';
          answer = answer.substring(0, answer.length - 1);
          this.updateCurrentKeyword({
            answer,
            answered: false,
          })
          break;
        // case 'delete':
        //   // #todo
        //   console.log('delete #todo')
      }
    },

    // Handles character presses, ie. a-z, space
    handleKeypress(e) {
      // Prevent [spacebar] from scrolling the page
      if(e.keyCode === 32) {
        e.stopPropagation();
        e.preventDefault();
      }

      const char = e.which !== 0 ? String.fromCharCode(e.which) : null;
      if( !this.currentKeyword) return;
      if( !char || _.contains([13], e.keyCode)) {
        // Skip some keys, like [enter]
        return;
      }

      // Fill the answer with char
      let answer = this.currentKeyword.answer || '';
      answer = answer + char;
      this.updateCurrentKeyword({answer, answered: false})
    },

    updateCurrentKeyword(changes) {
      const _uid = this.$store.state.studier.currentKeywordUID;
      this.$store.commit(`studier/UPDATE_KEYWORD`, {_uid, changes})
    },
  },

  computed: {
    ...mapState({
      currentMicroNoteIndex: state => state.studier.currentMicroNoteIndex,
    }),

    ...mapGetters({
      chapter: 'studier/chapter',
      microNotes: 'studier/microNotes',
      microNote: 'studier/currentMicroNote',
      currentKeyword: 'studier/currentKeyword',
    }),
  },

  data() {
    return {
      successImageUrl: null, // selected on create
      successGifs: [
        'https://media2.giphy.com/media/l3q2Z6S6n38zjPswo/200.gif',
        'https://media2.giphy.com/media/l0MYxef0mpdcnQnvi/200.gif',
        'https://media2.giphy.com/media/nXxOjZrbnbRxS/200w.gif',
        'https://media1.giphy.com/media/xNBcChLQt7s9a/200w.gif',
        'https://media0.giphy.com/media/13MCWeJPQtkdVe/200.gif',
        'https://media2.giphy.com/media/b09xElu8in7Lq/200.gif',
        'https://media3.giphy.com/media/rypyVNU547qrC/200.gif',
      ],
    }
  },

  watch: {
    'microNote.id'(newVal, oldVal) {
      if(newVal != oldVal) {
        // console.log(`currentMicroNote.id has changed from ${oldVal} to ${newVal}`)
        // we've changed the microNote, so reset the keywords
        this.$store.commit('studier/RESET_KEYWORDS');
      }
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>

  .wrapper {padding-bottom:120px;}
  /*Make room for #bottomShelf */
  .panel { margin-bottom: 0px; }

</style>



// WEBPACK FOOTER //
// ChapterStudier.vue?ca6179f0